var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"width":"100%","height":"700px","src":_vm.iframeUrl,"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }